<template>
  <VDialog v-model="isVisible" width="350px" persistent attach="#LetsPage">
    <VeeForm ref="observer">
      <VCard>
        <VCardTitle>
          {{ $t('C30101.C30101ChangeRegularSubjectDialog.CHjB-Ye9kNfIIozgCr2Ko') }}
        </VCardTitle>
        <VCardText v-debug>
          <h3>dialogData</h3>
          {{dialogData}}
        </VCardText>
        <VCardText v-if="dialogData">
          <table>
            <colgroup>
              <col style="width: fit-content;">
              <col style="width: fit-content;">
              <col style="width: max-content;">
            </colgroup>
            <tr>
              <td colspan="3">{{dialogData.currentSubjectTitle}}</td>
            </tr>
            <tr>
              <td>{{ $t('C30101.C30101ChangeRegularSubjectDialog.upVbPYtmRdESKF3scxLoU') }}</td>
              <td>:</td>
              <td class="pl-2 py-4">
                {{dialogData.timeDisplayName}}
              </td>
            </tr>
            <tr>
              <td>{{ $t('C20101.CourseTable.ke-mu') }}</td>
              <td>:</td>
              <td class="pl-2">
                <VAutocomplete
                  v-model="outputData.selectedSubject"
                  :items="dialogData.subjects || []"
                  hide-details="auto"
                  item-title="subject_name3"
                  return-object
                  clearable
                  density="compact"
                  variant="outlined"
                />
              </td>
            </tr>
          </table>
        </VCardText>
        <VCardText v-debug>
          <h3>outputData</h3>
          {{outputData}}
        </VCardText>
        <VCardActions>
          <VSpacer></VSpacer>
          <VBtn color="primary" size="small" :disabled="Object.keys(outputData?.selectedSubject || {}).length === 0" @click="emitOk">
            OK
          </VBtn>
          <VBtn variant="text" size="small" @click="emitCancel">
            {{ $t('common.cancel') }}
          </VBtn>
        </VCardActions>
      </VCard>
    </VeeForm>
  </VDialog>
</template>

<script>
import DialogMixin from '@/mixins/DialogMixin.js';
export default {
  components:{
  },
  mixins:[
    DialogMixin
  ],
  data() {
    return {
    };
  },
  methods:{
  }

}
</script>

<style scoped>
span {
  font-size: 1rem
}
.v-card__text{
  font-size: 1rem;
}
</style>
